import { ReactNode } from 'react';
import ConversationProviderContext from '@stores/contexts/conversation-context';

interface IConversationProviderProps {
  children: ReactNode;
}

const createConversationId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `conversation-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

const CONVERSATION_ID = createConversationId();

function ConversationProvider({ children, ...props }: IConversationProviderProps) {
  const value = {
    CONVERSATION_ID,
  };

  return (
    <ConversationProviderContext.Provider {...props} value={value}>
      {children}
    </ConversationProviderContext.Provider>
  );
}

export default ConversationProvider;
